import { Button } from "./Button";
import { GradientFilesIcon } from "@/components/Icons/Icons";
import { useAppDispatch, useAppSelector } from "@/hooks/types";
import { openModal } from "@/store/modal/slice";
import { getResumes } from "@/store/resume/selectors";
import { getIsCreditsEnabled } from "@/store/tenant/selectors";
import { getUserDocumentLimit } from "@/store/user/selectors";
import { ModalTypes } from "@/types/modal";

export const DocumentLimitButton = () => {
    const resumes = useAppSelector(getResumes);
    const documentLimit = useAppSelector(getUserDocumentLimit);
    const dispatch = useAppDispatch();
    const isCreditsEnabled = useAppSelector(getIsCreditsEnabled);

    const openDocumentLimitModal = () => {
        dispatch(openModal({ modalType: ModalTypes.DOCUMENT_LIMIT }));
    };

    if (!isCreditsEnabled) {
        return null;
    }

    return (
        <Button
            variant="outline"
            color="gradient"
            onClick={openDocumentLimitModal}
            className="!min-w-0 !px-3"
            leftIcon={<GradientFilesIcon className="h-4 w-4" />}
        >
            {resumes.length}/{documentLimit}
        </Button>
    );
};
